export const waMaxSizeText = 1000;
